module.exports = __webpack_public_path__ + "static/media/hdi-thumbs.bea8dd3a.svg";